import React from 'react';
import { FileQuestion } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const NotFoundError: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-md w-full transform transition-all duration-500 hover:shadow-2xl">
        {/* Error header with gradient background */}
        <div className="p-6 bg-gradient-to-r from-gray-700 to-gray-800">
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center">
              <FileQuestion className="h-8 w-8 text-gray-700" />
            </div>
          </div>
          <h2 className="mt-4 text-center text-2xl font-bold text-white">Page Not Found</h2>
        </div>
        
        {/* Error details */}
        <div className="p-6">
          <div className="mb-6">
            <div className="text-center text-gray-600 mb-4">
              The page you're looking for doesn't exist or has been moved.
            </div>
            
            {/* Error code display */}
            <div className="bg-gray-100 rounded-lg p-3 font-mono text-sm text-center text-gray-700">
              Error Code: 404_NOT_FOUND
            </div>
          </div>
          
          {/* Action buttons */}
          <div className="flex flex-col space-y-3">
            <Link
              to="/"
              className="w-full py-3 bg-gray-700 text-white rounded-lg font-medium transition hover:bg-gray-800 flex items-center justify-center space-x-2"
            >
              <span>Return to Home</span>
            </Link>
            
            <button
              onClick={() => navigate(-1)}
              className="w-full py-3 bg-gray-200 text-gray-800 rounded-lg font-medium transition hover:bg-gray-300 flex items-center justify-center space-x-2"
            >
              <span>Go Back</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundError;